import { splitNumbersIntoGroups } from '../Array'

/**
 * Returns a new array with inventory that is the same merged into one item
 * @param {Array<inventory>}
 * @returns {Array<inventory>}
 */
export function groupSameInventory(inventory) {
  var clone
  var groupedInventory = []
  inventory.forEach((item, index) => {
    var firstMatchingIndex = groupedInventory.findIndex(i =>
      inventoryEqualityCheck(i, item),
    )
    if (firstMatchingIndex !== -1) {
      clone = groupedInventory[firstMatchingIndex]
      clone.quantity += item.quantity
    } else {
      clone = Object.assign({}, item)
      groupedInventory.push(clone)
    }
  })
  return groupedInventory
}

/**
 * Returns if two inventory items are the same, in the sense of matching
 * item type, size, client and city.
 * @param {Inventory} a
 * @param {Inventory} b
 * @returns {boolean}
 */
function inventoryEqualityCheck(a, b) {
  return a.inventoryId === b.inventoryId && a.city_id === b.city_id
}

/**
 * Filters inventory movements by city id
 * @param {Array} movements
 * @param {Number} cityId
 * @returns {Array<Object>} Filtered array
 */
export const filterMovementsByCity = (movements, cityId) => {
  if (!movements) {
    // loading
    return []
  }
  return movements.filter(movementItem => movementItem.relatedCityId == cityId)
}

/**
 * Pure function that accepts an array of integers (number of houses per mission) and returns an array of objects.
 * The first value being the pack size, and the second value being the quantity (how many packs of this size we need)
 *
 * @param {array} args.numbers Array of addresses that we want to split into packs
 * @param {number} args.step Step of the pack size (if step is 100 then pack size could be e.g. 100, 200, 300 and so on)
 * @param {number} args.maxGroups Max number of different pack sizes
 *
 * @returns {Array<number>} New numbers in the same order with the new pack
 * sizes.
 */
export const generatePacksSizesByMissionsAddresses = ({
  numbers = [],
  maxGroups = 3,
  step = 100,
  minimumNonFloorNumber = 200,
}) => {
  const groupsMap = splitNumbersIntoGroups({
    numbers,
    step,
    maxGroups,
    minimumNonFloorNumber,
  })

  var valuesToGroupMap = {}
  for (var groupVal in groupsMap) {
    groupsMap[groupVal].forEach(n => (valuesToGroupMap[n] = Number(groupVal)))
  }
  return numbers.map(n => Number(valuesToGroupMap[n]))
}
